//export default function onSimpleImageUploadSuccess({remoteStorageResourceId,imageSpec,storageLocation,args},dispatch){ }

import A from './ActionCreators.js';
import C from './Constants';

const onSimpleImageUploadSuccess = ({remoteStorageResourceId,imageSpec,storageLocation},dispatch) => res => {



  let { _id, version, imageId } = imageSpec;
  _id = _id || imageId;

  let postData = res.json;

  dispatch(A.clearPostData({imageSpec}))
  //clearPostData(imageSpec,dispatch);

  if( res.status !== 204 && imageSpec.version === 'raw' ){
    dispatch(

      A.pushNotification({
        notificationType:C.imageSyncFailure,
        args:{ imageId:_id }
      })
    )
    return;
  }

  //let remoteStorageResourceId = postData.fields.key;
  

  dispatch(A.setRemoteStorageResourceId({
    _id, 
    version,
    pendingRecords:true,
    storageLocation,
    remoteStorageResourceId
  }))
  return true;

}

export default onSimpleImageUploadSuccess;
